module.exports = __webpack_public_path__ + "static/media/service_design.a5ab299b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/smartinsure/service_design.png
// module id = 632
// module chunks = 0